import { FC } from 'react';
import { cx } from '@emotion/css';
import { useTranslation } from 'next-i18next';

import { DSButton } from '@stihl-design-system/components';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

import { ViewerImageType } from '../image-viewer/image-viewer';

interface MainImageButtonProps {
  selectedImage: ViewerImageType;
  onSetMainImage: (id: string) => void;
  inModal?: boolean;
}

export const MainImageButton: FC<MainImageButtonProps> = ({ selectedImage, onSetMainImage, inModal = false }) => {
  const { t } = useTranslation('shared');
  const { id, isMainImage } = selectedImage;

  return isMainImage ? (
    <div
      className="flex items-center justify-center gap-x-2 bg-primary-orange px-2 py-1 stihl-text-interactive-button tablet:px-4 min-h-[2rem]"
      data-testid="main-image-label"
    >
      <PhoenixIcon icon={getDesignSystemIcon('icon-star-16.svg')} />
      <span className={cx({ 'hidden desktop:block': !inModal })}>{t('shared_imageUpload_tag_main')}</span>
    </div>
  ) : (
    <DSButton
      size="small"
      iconName="star"
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        e.stopPropagation();
        onSetMainImage(id);
      }}
      aria-label={`${t('shared_imageUpload_button_main')} (${selectedImage.originalFilename})`}
      data-testid="set-main-image-btn"
    >
      {t('shared_imageUpload_button_main')}
    </DSButton>
  );
};
